<template lang="pug">
md-layout(md-column)
  // Page loader
  md-progress.md-accent(md-indeterminate='', v-if='loadingComponent')
  // Page content
  md-theme(md-name='blue', v-else)
    // Title
    breadcrumbs#scrollToError(section='Distributions', :nav='nav')

    // Form
    md-layout.form-wrapper(:md-gutter='16')
      // Preview
      md-layout(md-flex='100', v-if='$route.params.id !== undefined')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          video-preview(
            :distributionId='$route.params.id',
            :playerSettings='distribution.playerSettings',
            @copiedToClipBoard='showAlertToast("Copied to the clipboard!", "success")'
          )
      // Images
      md-layout(md-flex='100')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          .md-headline Images
            p.errorMessage(v-if='noImagesLive') If status is "live" the images are required
            ImageUploadCroped(:accountID='accountID', @uploadSuccessPoster='onUploadDistributionPoster', @uploadSuccessHero='onHeroImageUploadSuccess', :media-item="distribution", :is-distribution="true")
      // Distribution
      md-layout(md-flex='50', md-flex-small='100')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          metadata-form(title='Distribution', :editMode='editMode', :entity='distribution', :form-submitted='formSubmitted', :validations='$v.distribution')
      // Publishing
      md-layout(md-flex='50', md-flex-small='100')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          publishing-form(:distribution='distribution', :form-submitted='formSubmitted', :validations='$v.distribution', :date-valid='dateValid', @price-selected='handlePriceSelected')
      // Content
      md-layout(md-flex='100')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          content-form(
            :source='distribution.source',
            :form-submitted='formSubmitted',
            :validations='$v.distribution.source',
            @error='showAlertToast($event, "error")',
            @onSetCustomSort='setCustomSort',
            @playlist-items='setPlaylistItems',
            :savePlaylistOrder='savePlaylistOrder',
          )
      // Categories
      md-layout(md-flex='100')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          sections(:entity='distribution', :playlist-items='playlistItems', @currentsections='currentSections')
      // Qortex
      md-layout(md-flex='33', md-flex-small='100')
        md-whiteframe.form-wrapper-frame(md-elevation='3', md-align='100')
          qortex(:key="qortexKey", :qortex-data="distribution.ads.qortex", :non-linear-enabled="distribution.ads.nonLinearEnabled", @cancel-dialog="resetQortexDialog", @qortex-updated="updateQortexData", @non-linear-updated="updateNonLinearEnabled")
          .md-headline VAST tags
          p.invalidURL(v-if="!isValidUrl && newUrl !== ''") {{ errorMessage }}
          p.Urlok(v-if="isValidUrl && newUrl !== ''") URL is valid
          md-input-container
            label {{ distribution.vastTagUrls.length >= 5 ? 'Urls cannot be more than 5' : 'Add URL' }}
            md-input(v-model='newUrl', type='text', @keydown.enter.native='addUrl', :disabled='distribution.vastTagUrls.length >= 5', @input="validateUrl(newUrl, 'isValidUrl')", :class="{ 'is-invalid': !isValidUrl }")
            md-button.md-icon-button.md-raised.btn(@click='addUrl', v-if="distribution.vastTagUrls.length < 5", :disabled='!newUrl')
              md-icon.icon(md-iconset="fa fa-plus")
          md-list
            md-list-item.list(v-for='url in distribution.vastTagUrls' :key='url')
              a(target="_blank", rel="noopener noreferrer", :href='url.startsWith("https://") ? url : "https://" + url').text-list {{ url }}
              md-button#btn-delete(@click='distribution.vastTagUrls.splice(distribution.vastTagUrls.indexOf(url), 1)') X

          .md-headline Display Ads
          p.invalidURL(v-if="!isValidDisplayAdServerUrl && newDisplayAdServerUrl !== ''") Invalid URL
          p.Urlok(v-if="isValidDisplayAdServerUrl && newDisplayAdServerUrl !== ''") URL is valid
          md-input-container
            label {{ distribution.displayAdTagUrls.length >= 5 ? 'Urls cannot be more than 5' : 'Add URL' }}
            md-input(v-model='newDisplayAdServerUrl', type='text', @keydown.enter.native='addDisplayAdServerUrl', :disabled='distribution.displayAdTagUrls.length >= 5', @input="validateUrl(newDisplayAdServerUrl, 'isValidDisplayAdServerUrl')", :class="{ 'is-invalid': !isValidDisplayAdServerUrl }")
            md-button.md-icon-button.md-raised.btn(@click='addDisplayAdServerUrl', v-if="distribution.displayAdTagUrls.length < 5", :disabled='!isValidDisplayAdServerUrl')
              md-icon.icon(md-iconset="fa fa-plus")
          md-list
            md-list-item.list(v-for='url in distribution.displayAdTagUrls' :key='url')
              a(target="_blank", rel="noopener noreferrer", :href='url.startsWith("https://") ? url : "https://" + url').text-list {{ url }}
              md-button#btn-delete(@click='distribution.displayAdTagUrls.splice(distribution.displayAdTagUrls.indexOf(url), 1)') X

      md-layout(md-flex='33', md-flex-small='100')
        // Domains
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          domains-form(:entity='distribution', @created='showAlertToast($event, "success")', @error='showAlertToast($event, "error")')
        // Share url settings
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          sns-share-form(:share-urls='socialMediaShareUrls', @clear-input='handleClearInput')
      // Player Settings
      md-layout(md-flex='33', md-flex-small='100')
        md-whiteframe.form-wrapper-frame(md-elevation='3')
          player-settings-form(
            :playerSettings='distribution.playerSettings',
            :isLive='false',
            :form-submitted='formSubmitted',
            :validations='$v.distribution.playerSettings'
          )

      md-layout(md-align='center')
        stitch-loader(:loading='creatingOrUpdatingView', :size='40')
        md-button#submit-btn.md-raised.md-primary(@click='onFormSubmit', v-show='!creatingOrUpdatingView', :disabled="$v.$pending")
          | {{ editMode ? 'Update' : 'Create' }}
</template>

<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required, url } from "vuelidate/lib/validators";
import {
  isValidDate,
  isValidDomain,
  requiredIfBannerEnabled,
} from "../../services/validatorService";
import distributionService from "../../services/distributionService";
import StitchLoader from "../../shared-components/Loader";
import MetadataForm from "../../shared-components/forms/MetadataForm";
import ContentForm from "../../shared-components/distribution/form-components/ContentForm";
import DomainsForm from "../../shared-components/forms/DomainsForm";
import PlatformsForm from "../../shared-components/forms/PlatformsForm";
import PlayerSettingsForm from "../../shared-components/distribution/form-components/PlayerSettingsForm";
import AdsForm from "../../shared-components/distribution/form-components/AdsForm";
import PublishingForm from "../../shared-components/distribution/form-components/PublishingForm";
import SnsShareForm from "../../shared-components/distribution/form-components/SnsShareForm.vue";
import VideoPreview from "../../shared-components/video/VideoPreview";
import Breadcrumbs from "../../shared-components/Breadcrumbs";
import channelService from "../../services/channelService";
import networkService from "../../services/networkService";
import DistributionPoster from "../../shared-components/upload/DistributionPoster.vue";
import HeroImageUploader from "../../shared-components/upload/HeroImageUploader.vue";
import ImageUploadCroped from "../../shared-components/upload/ImageUploadCroped.vue";
import Sections from "../../shared-components/distribution/form-components/Sections.vue";
import Qortex from "../../shared-components/forms/QortexForm.vue";
import shareUrlService from "../../services/shareUrlService";

export default {
  mixins: [validationMixin],
  components: {
    MetadataForm,
    ContentForm,
    DomainsForm,
    PlatformsForm,
    PlayerSettingsForm,
    AdsForm,
    PublishingForm,
    SnsShareForm,
    StitchLoader,
    VideoPreview,
    Breadcrumbs,
    DistributionPoster,
    HeroImageUploader,
    ImageUploadCroped,
    Sections,
    Qortex,
  },
  computed: {
    ...mapState({
      siteuser: (state) => state.user.siteuser,
      accountID: (state) => state.user.siteuser.user_metadata.account_id,
    }),

    nav() {
      return [
        { title: "Distributions", route: "DistributionList" },
        { title: this.editMode ? "Edit Distribution" : "New Distribution" },
      ];
    },
    editMode() {
      return !!this.$route.params.id;
    },
    creatingOrUpdatingView() {
      return [
        this.creatingOrUpdating,
      ].some(Boolean);
    }
  },
  data() {
    return {
      qortexKey: 0,
      customSort: [],
      playlistItems: [],
      loadingComponent: true,
      creatingOrUpdating: false,
      distributionOriginalName: null,
      formSubmitted: false,
      savePlaylistOrder: false,
      newUrl: "",
      isValidUrl: true,
      newDisplayAdServerUrl: "",
      isValidDisplayAdServerUrl: true,
      noImagesLive: false,
      distribution: {
        vastTagUrls: [],
        displayAdTagUrls: [],
        name: "",
        description: "",
        shortDescription: "",
        poster: "",
        heroImage: "",
        status: "draft",
        tags: [],
        prices: [],
        startDate: "",
        endDate: "",
        source: {
          type: "playlist",
          playlist: null,
          network: null,
          channel: null,
          params: {
            length: 5,
            sort: {
              by: "lastUpdated",
              order: "desc",
            },
            keywordsBlocking: [],
          },
        },
        sections: [{
          name: "Most Popular",
          key: "shortFormVideos",
          type: "singlevideo",
          tagsAssociated: ["most popular"],
          categoriesAssociated: [],
          seriesAssociated: [],
          customSort: [],
          visible: true,
        }],
        playerSettings: {
          minimumSize: "640x480",
          activation: "click",
          fullscreen: true,
          sound: true,
          soundLevel: 50,
          playIfAdShown: false,
          domain: "",
        },
        platforms: {
          mobile_web: true,
          mobile_app: true,
          tablet: true,
          desktop: true,
          connectedtv: true,
          ott: false,
        },
        outletList: {
          mode: "whitelist",
          domainLists: [],
        },
        ads: {
          dfpEnabled: false,
          nonLinearEnabled: false,
          networkCode: "",
          advertiserId: "",
          orderId: "",
          lineItemId: "",
          adUnitId: "",
          adUnitTag: "",
          default: "",
          default_failover: [],
          mobile: "",
          mobile_failover: [],
          banner: {
            enabled: false,
            link: "",
            image: "",
          },
          ooyala: {
            pulseHost: null,
            category: null,
          },
          qortex: {
            groupId: "",
            bundleId: "",
            marketplaceId: "",
            storeId: ""
          },
        },
      },
      socialMediaShareUrls: [{type: 'facebookShare', url: ''}, {type: 'instagramShare', url: ''}],
      dateValid: true,
    };
  },
  validations: {
    distribution: {
      name: {
        required,
        async isUnique(value) {
          const hasToCheck =
            !this.editMode || value !== this.distributionOriginalName;
          if (value && hasToCheck) {
            const response = await distributionService.getList({
              exactName: value,
              limit: 1,
            });
            return response.data.distributions.length === 0;
          } else {
            return true;
          }
        },
      },
      shortDescription: {
        required,
      },
      description: {
        required,
      },
      startDate: {
        validDate(value) {
          if (this.distribution.status === 'public') {
            return value ? isValidDate(value) : false;
          } else {
            return true;
          }
        }
      },
      endDate: {
        validDate(value) {
          if (this.distribution.status === 'public') {
            return value ? isValidDate(value) : false;
          } else {
            return true;
          }
        }
      },
      poster: {
        validStatus(value) {
          if (
            this.distribution.status !== "public" &&
            (value !== "false" || !!value)
          ) {
            return true;
          } else {
            return required(value);
          }
        },
      },
      heroImage: {
        validStatus(value) {
          if (
            this.distribution.status !== "public" &&
            (value !== "false" || !!value)
          ) {
            return true;
          } else {
            return required(value);
          }
        },
      },
      source: {
        playlist: {
          required(value) {
            return this.distribution.source.type !== "playlist" || !!value;
          },
        },
        network: {
          required(value) {
            return this.distribution.source.type !== "network" || !!value;
          },
        },
        channel: {
          required(value) {
            return this.distribution.source.type !== "channel" || !!value;
          },
        },
      },
      playerSettings: {
        domain: {
          validDomain(value) {
            if (!value) return true;
            return isValidDomain(value.trim());
          },
        },
      },
      ads: {
        default: {
          url,
        },
        default_failover: {
          $each: {
            url,
          },
        },
        mobile: {
          url,
        },
        mobile_failover: {
          $each: {
            url,
          },
        },
        banner: {
          link: {
            requiredIfBannerEnabled,
            url,
          },
          image: {
            requiredIfBannerEnabled,
            url,
          },
        },
        ooyala: {
          pulseHost: {
            required(value) {
              return !!value || !this.distribution.ads.ooyala.category;
            },
            url,
          },
          category: {
            required(value) {
              return !!value || !this.distribution.ads.ooyala.pulseHost;
            },
          },
        },
      },
    },
  },
  methods: {
    showAlertToast(text, icon) {
      this.$swal({
        text: text,
        position: "bottom-left",
        icon: icon,
        toast: true,
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
    },

    updateQortexData(updatedQortex) {
      this.distribution.ads.qortex = updatedQortex;
    },
    updateNonLinearEnabled(isEnabled) {
      this.distribution.ads.nonLinearEnabled = isEnabled;
    },
    resetQortexDialog() {
      this.qortexKey += 1;
    },

    handlePriceSelected(price) {
      this.distribution.prices[0] = price;
    },
    addUrl() {
      if (
        this.newUrl &&
        this.distribution.vastTagUrls.length < 5 &&
        this.isValidUrl
      ) {
        this.distribution.vastTagUrls.push(this.newUrl);
        this.newUrl = "";
      }
    },
    addDisplayAdServerUrl() {
      if (
        this.newDisplayAdServerUrl &&
        this.distribution.displayAdTagUrls.length < 5 &&
        this.isValidDisplayAdServerUrl
      ) {
        this.distribution.displayAdTagUrls.push(this.newDisplayAdServerUrl);
        this.newDisplayAdServerUrl = "";
      }
    },
    validateUrl(url, stateToHoldResult) {
      const urlRegex =
        /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-{}]*)*(\?[\w\-\/.&%={}]*)*(#.*)?( ?(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-{}]*)*(\?[\w\-\/.&%={}]*)*(#.*)?)*$/;
      this.isValidUrl = urlRegex.test(this.newUrl);
      if (!this.isValidUrl) {
        this.errorMessage = "Invalid URL";
      } else {
        this.errorMessage = "";
      }
    },
    currentSections(sections) {
      this.distribution.sections = sections;
    },

    setCustomSort(data) {
      this.customSort = data;
    },
    setPlaylistItems(items) {
      this.playlistItems = items;
    },

    onUploadDistributionPoster({ url }) {
      this.distribution.poster = url;
    },
    onHeroImageUploadSuccess({ url }) {
      this.distribution.heroImage = url;
    },

    updateChannelOrNetwork() {
      const formedCustomSort = this.customSort.map(
        (mediaitem) => mediaitem._id
      );
      if (this.distribution.source.network !== null) {
        return networkService
          .get(this.distribution.source.network)
          .then((response) => {
            const network = response.data.network;
            return networkService.update(network._id, {
              ...network,
              customSort: formedCustomSort,
            });
          });
      } else if (this.distribution.source.channel !== null) {
        return channelService
          .get(this.distribution.source.channel)
          .then((response) => {
            const channel = response.data.channel;
            return channelService.update(channel._id, {
              ...channel,
              customSort: formedCustomSort,
            });
          })
          .catch(() => {
            this.showAlertToast(
              "Channel data could not be retrieved. Please, try again later.",
              "error"
            );
          });
      }
      return null;
    },
    async updateShareUrls() {
      const toUpdate = [], toDelete = [];

      this.socialMediaShareUrls.forEach((item) => {
        // If item has _id and url is not present, we want to delete it
        if (item._id && !item.url) toDelete.push(item);
        // Otherwise, we want to update it
        else toUpdate.push(item);
      });

      const updateOps = toUpdate.map(({ type, url }) => {
        // Share url create endpoint does an upsert
        return shareUrlService.create({ type, url, distribution: this.$route.params.id });
      });

      const deleteOps = toDelete.map(({ _id }) => {
        return shareUrlService.delete(_id);
      })

      await Promise.all([updateOps, deleteOps].flat());

      this.creatingOrUpdating = false;
      return null;
    },
    createDistribution() {
      this.creatingOrUpdating = true;
      distributionService
        .create(this.distribution)
        .then(() => {
          this.savePlaylistOrder = !this.savePlaylistOrder;
          return this.updateChannelOrNetwork();
        })
        .catch(() => {
          this.showAlertToast(
            "Distribution could not be created. Please, try again later.",
            "error"
          );
        })
        .then(() => {
          this.showAlertToast("Distribution created successfully", "success");
          this.$delayedNavigation(this.$router, 'DistributionList');
        })
        .then(() => {
          this.creatingOrUpdating = false;
        });
    },
    updateDistribution() {
      this.creatingOrUpdating = true;

      distributionService
        .update(this.$route.params.id, this.distribution)
        .then(() => {
          this.savePlaylistOrder = !this.savePlaylistOrder;
          return this.updateChannelOrNetwork();
        })
        .catch(() => {
          this.showAlertToast(
            "Distribution could not be updated. Please, try again later.",
            "error"
          );
        })
        .then(() => {
          this.showAlertToast("Distribution updated successfully", "success");
          this.$delayedNavigation(this.$router, 'DistributionList');
          this.creatingOrUpdating = false;
        });
    },
    checkInvalidImages() {
      return (
        this.distribution.status === "public" &&
        (this.distribution.heroImage === "false" ||
          this.distribution.heroImage === "" ||
          this.distribution.poster === "false" ||
          this.distribution.poster === "")
      );
    },
    onFormSubmit() {
      this.noImagesLive = false;
      this.formSubmitted = true;
      const today = new Date();
      const endDate = new Date(this.distribution.endDate);
      const startDate = new Date(this.distribution.startDate);
      setTimeout(() => {
        if (
          this.distribution.status === "draft" ||
          (endDate >= today && endDate >= startDate)
        ) {
          this.dateValid = true;
        } else {
          this.dateValid = false;
        }
        if (!this.$v.$invalid && this.dateValid) {
          if (this.editMode) {
            if (this.checkInvalidImages()) {
              this.noImagesLive = true;
              const scrollToError = this.$el.querySelector("#scrollToError");
              scrollToError.scrollIntoView({ behavior: "smooth" });
            } else {
              this.noImagesLive = false;
              this.updateDistribution();
              this.updateShareUrls();
            }
          } else {
            this.noImagesLive = false;
            this.createDistribution();
            this.updateShareUrls();
          }
        } else {
          if (this.checkInvalidImages()) this.noImagesLive = true;
          const scrollToError = this.$el.querySelector("#scrollToError");
          scrollToError.scrollIntoView({ behavior: "smooth" });
        }
      }, 800);
    },
    handleClearInput(index) {
      this.socialMediaShareUrls[index].url = "";
    },
  },
  async mounted() {
    const sourceType = this.$route.query.sourceType;
    const sourceId = this.$route.query.sourceId;
    this.loadingComponent = true;
    if (this.editMode) {
      distributionService
        .get(this.$route.params.id)
        .then((response) => {
          const data = response.data.distribution;
          if (!data.ads.ooyala) {
            Object.assign(data.ads, {
              ooyala: {
                pulseHost: null,
                category: null,
              },
            });
          }
          if (!data.ads.qortex) {
            Object.assign(data.ads, {
              qortex: {
                groupId: "",
                bundleId: "",
                marketplaceId: "",
                storeId: ""
              },
              nonLinearEnabled: false
            });
          }
          if (!data.displayAdTagUrls) data.displayAdTagUrls = [];
          if (!data.playerSettings) {
            data.playerSettings = {
              minimumSize: "640x480",
              activation: "click",
              fullscreen: true,
              sound: true,
              soundLevel: 50,
              playIfAdShown: false,
              domain: "",
            };
          } else if (data.playerSettings.domain === undefined) {
            data.playerSettings.domain = "";
          }

          this.distribution = data;

          if (this.distribution.startDate) {
            this.distribution.startDate = this.distribution.startDate.substr(
              0,
              10
            );
          }
          if (this.distribution.endDate) {
            this.distribution.endDate = this.distribution.endDate.substr(0, 10);
          }
          this.distributionOriginalName = this.distribution.name;
          const mostPopularRegex = /^(most\s+popular|mostpopular)$/i;
          if (!this.distribution.sections.find((section) => mostPopularRegex.test(section.name.trim()))) {
              this.distribution.sections.unshift({
                name: "Most Popular",
                key: "shortFormVideos",
                type: "singlevideo",
                tagsAssociated: ["most popular"],
                categoriesAssociated: [],
                seriesAssociated: [],
                customSort: [],
                visible: false,
              });
            }
        })
        .catch(() => {
          this.showAlertToast(
            "Distribution data could not be retrieved. Please, try again later.",
            "error"
          );
        })
        .then(async () => {
          // load share urls
          const supportedNetworks = ['facebookShare', 'instagramShare'];
          const urlsResponse = await shareUrlService.getList({ distribution: this.$route.params.id });

          const newUrls = urlsResponse.data.shareUrl;

          supportedNetworks.forEach((type) => {
            if (!newUrls.find((url) => url.type === type)) {
              newUrls.push({
                type,
                url: ''
              })
            }
          })

          this.socialMediaShareUrls = newUrls;
        })
        .catch((err) => {
          console.error(err);
        })
        .then(() => {
          this.loadingComponent = false;
        });
    } else if (sourceType && sourceId) {
      this.distribution.source.type = sourceType;
      this.distribution.source[sourceType] = sourceId;
    }
    this.loadingComponent = false;
  },
};
</script>

<style lang="scss" scoped>
.errorMessage {
  color: #ff5722;
  font-size: 16px;
}

.invalidURL {
  color: rgb(224, 4, 4);
}

.Urlok {
  color: rgb(5, 227, 5);
}

.btn {
  margin-bottom: 5px;
}

.icon {
  margin: auto !important;
}

#btn-delete {
  color: rgb(255, 0, 0);

  &:hover {
    transform: scale(1.2);
    color: rgb(255, 0, 0) !important;
    background-color: transparent !important;
  }
}

.list {
  margin-bottom: 5px;
  background-color: rgb(247, 244, 244);
  border-radius: 4px;
}

.text-list {
  display: inline-block;
  max-width: 500px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.form-wrapper {
  width: 100%;
  padding: 25px 10%;

  @media (max-width: 1200px) {
    padding: 10px 0.5%;
    margin-left: 0;
  }

  .md-layout {
    margin-bottom: 5px;
  }
}

.form-wrapper-frame {
  width: 100%;
  padding: 25px;
  margin-bottom: 15px;
}

.title-icon {
  margin-top: -5px;
}

#submit-btn {
  margin: 25px 0;
  width: 33%;
  padding: 6px;
  font-size: 1.1em;
}
</style>



// WEBPACK FOOTER //
// src/spa/distribution/DistributionForm.vue